var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { useLoaderData, useParams } from 'react-router';
import { useAtomValue } from 'jotai';
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";




import { templatesAtom } from "../../../atoms";
import { ParagraphsTable } from "./components/paragraphs/Table";
import { ViewParagraphSidePanel } from "./components/paragraphs/ViewParagraphSidePanel";
import { PDFSidepanel } from "./components/paragraphs/PDFSidepanel";

const PXParagraphDashboard = () => {
  const { extractorId } = useParams();
  const { rows, totalRows, extractor, sourceEntity } = useLoaderData();
  const templates = useAtomValue(templatesAtom);
  const [sidePanel, setSidePanel] = useState(false);
  const [pdfSidepanel, setPdfSidepanel] = useState(false);
  const [paragraphOnView, setParagraphOnView] = useState(
    undefined
  );

  const template = templates.find((temp) => temp._id === (extractor === null || extractor === void 0 ? void 0 : extractor.sourceTemplateId));
  const paragraphEntities = rows === null || rows === void 0 ? void 0 : rows.flatMap((row) => [
  row,
  ...(row.subRows || []).map((subrow) => subrow)]
  );

  const onViewEntity = (entityId) => {
    const selectedParagraph = paragraphEntities === null || paragraphEntities === void 0 ? void 0 : paragraphEntities.find((paragraph) => paragraph._id === entityId);
    setParagraphOnView(selectedParagraph);
    setSidePanel(true);
  };
  const entityTitle = (sourceEntity === null || sourceEntity === void 0 ? void 0 : sourceEntity.title) || '';

  return (/*#__PURE__*/
    _jsx("div", { className: "h-full w-full overflow-y-auto", "data-testid": "settings-paragraph-extractor" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: entityTitle,
      path:
      new Map([
      ['Paragraph extraction', '/settings/paragraph-extraction'],
      [`${template === null || template === void 0 ? void 0 : template.name}`, `/settings/paragraph-extraction/${extractorId}/entities`]]
      ) }

    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(ParagraphsTable, {
      pxParagraphData: rows || [],
      viewParagraph: onViewEntity,
      totalRows: totalRows,
      openPDFSidepanel: setPdfSidepanel }
    )
    )
    ), /*#__PURE__*/
    _jsx(ViewParagraphSidePanel, {
      isSidePanelOpen: sidePanel,
      setIsSidePanelOpen: setSidePanel,
      paragraphOnView: paragraphOnView }
    ), /*#__PURE__*/
    _jsx(PDFSidepanel, {
      entity: sourceEntity,
      setShowSidepanel: setPdfSidepanel,
      showSidepanel: pdfSidepanel }
    )
    ));

};

export { PXParagraphDashboard };